import React from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

import { useTimeModal } from '../TimeModal/TimeModalContext';

import Loading from '../Loading';
import WarningPanel from '../WarningPanel';

const CaseInterval = ({ userId }) => {
  const { openTimeModal } = useTimeModal();

  const [isFormChanged, setIsFormChanged] = React.useState(false);
  const [formInfo, setformInfo] = React.useState({
    id: '',
    value: '',
  });

  const [isAdmin, setIsAdmin] = React.useState(false);

  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(true);
  const [warning, setWarning] = React.useState('');
  const [status, setStatus] = React.useState(<a>Сохраните изменения</a>);

  const handleLogout = () => {
      localStorage.removeItem('token');
      window.location.href = '/';
  }

  React.useEffect(() => {
      const token = localStorage.getItem('token');
      if (!token) handleLogout();

      const decodedToken = jwtDecode(token);

      if (decodedToken.role==='АппаратСРО') setIsAdmin(true);

      axios.get(`/api/get-system-setting?setting=bid_interval`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
          setformInfo(response.data);
          
          setIsFormChanged(false);
      }).catch((error) => {
          console.error(error);
          setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
      }).finally(() => {
        setReload(false);
        setLoading(false);
      });
  }, [reload, userId]);

  const handleChange = (field) => (e) => {
    const value = e.target.value;

    if (!/^\d*$/.test(value)) return;

    setformInfo((prev) => ({ ...prev, [field]: value }));
    setIsFormChanged(true);

    setErrorsForm((prevErrors) => {
      if (!prevErrors[field]) return prevErrors;
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[field];
      return updatedErrors;
    });
  };

  const [errorsForm, setErrorsForm] = React.useState({});
  const validateForm = () => {
    const newErrors = {};

    if (!formInfo.value) {
      newErrors.value = 'Обязательное поле';
    }

    setErrorsForm(newErrors);
    if (Object.keys(newErrors).length > 0) {
        setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
        return false;
    } else {
        return true;
    }
  };

  const changeData = () => {
    const token = localStorage.getItem('token');
    const formData = new FormData();

    formData.append('bid_interval', formInfo.bid_interval);

    axios.put('/api/change-system-setting', {
        id: formInfo.id,
        value: formInfo.value,
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    })
    .then(() => {
      setStatus(<a>Данные сохранены</a>);
      openTimeModal('Данные успешно сохранены', 'success');
      setReload(true);
      setIsFormChanged(false);
    })
    .catch((error) => {
      console.error(error);
      setStatus(<a className='mainLabelError'>{`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`}</a>);
    })
  };

  const handleSave = () => {
    setLoading(true);
    setStatus(<a><Loading type='inline' /></a>);
    if (validateForm()) {
      changeData();
    }
    setLoading(false);
  };
  

  return (
    <div className='pageLimiter'>
      {loading ? <Loading />
      : warning ? <WarningPanel text={warning} />
      :
      <>
        <div className='labelInputWrapper'>
          <a className='label'>Срок исполнения заявки</a>
          <div className='labelInputRight'>
            <div className='inputWrapper'>
              <input 
                type='text' 
                value={formInfo.value} 
                onChange={handleChange('value')} 
                className={errorsForm.value ? 'inputError' : ''}
                placeholder='В днях' 
                minLength='' 
                maxLength='3' 
                disabled={loading}
                required />
              <p className='description'>Этот срок автоматически применяется ко всем карточкам со статусом «Заявка». К дате начала учёта прибавляется указанное выше количество дней, чтобы определить крайний день утверждения кандидатуры арбитражного управляющего СРО</p>
              {errorsForm.value && <div className='errorUnderInput'>{errorsForm.value}</div>}
            </div>
          </div>
        </div>

        {isFormChanged &&
          <div className='panelFormConfirmation'>
            <div className='horizontalContainer'>
              <button type='button' className='button' onClick={handleSave} disabled={loading}>Сохранить</button>
              <button type='button' className='button optionalButton' onClick={() => setReload(true)}>Отменить</button>
            </div>
            <div>{status}</div>
          </div>
        }
      </>
      }
    </div>
  )
}

export default CaseInterval;